// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hFx_W","fullView":"styles_fullView__1BFBH"};